import axios from '@axios';


const getUsersCompany = () => {
  return axios.get('/users/company')
};

export default {
  getUsersCompany,
};